export enum CustomerSegment {
  CORE_CUSTOMER = 'CORE_CUSTOMER',
  NON_CORE_COMMERCIAL_CUSTOMER = 'NON_CORE_COMMERCIAL_CUSTOMER',
  PRIVATE_CUSTOMER = 'PRIVATE_CUSTOMER',
  NON_CUSTOMER = 'NON_CUSTOMER',
}
